import React, { forwardRef } from "react";
import { Alert, Flex, Input, Text, Wrap } from "@chakra-ui/react";

export type VisualAccuityProps = {
  name: string;
  value?: string;
  disabled?: boolean;
  fontSize?: string;
  height?: string;
  paddingY?: string;
  country: string;
  dataTestId?: string;
  onChange?: (value: string) => void;
};
export const VisualAccuity: React.FC<VisualAccuityProps> = forwardRef<
  HTMLInputElement,
  VisualAccuityProps
>((props, ref) => {
  const {
    name,
    value,
    disabled,
    fontSize = "2xl",
    height = "auto",
    paddingY = 2,
    country,
    onChange,
  } = props;
  const dataTestId = props.dataTestId ?? name;

  const inputBGColor = disabled ? "gray.100" : "white";
  const hoverStyle = {
    borderColor: disabled ? "gray.500" : "blue.500",
  };
  const placeholderStyle = {
    color: "gray.300",
  };

  switch (country) {
    case "DE":
      return (
        <>
          <Wrap align="center">
            <Input
              data-testid={dataTestId}
              ref={ref}
              type="text"
              borderColor="gray.500"
              name={name}
              value={value}
              width="20"
              placeholder={"100"}
              _disabled={{
                opacity: 1,
              }}
              backgroundColor={inputBGColor}
              disabled={disabled}
              isReadOnly={disabled}
              fontSize={fontSize}
              height={height}
              paddingY={paddingY}
              onChange={(e) => {
                onChange?.(e.target.value);
              }}
              _hover={hoverStyle}
              _placeholder={placeholderStyle}
            />
            <Text fontSize="xl">%</Text>
          </Wrap>
        </>
      );
    case "FR":
      return (
        <Wrap align="center">
          <Input
            data-testid={dataTestId}
            type="text"
            borderColor="gray.500"
            name={name}
            value={value}
            width="24"
            onChange={(e) => {
              onChange?.(e.target.value);
            }}
            placeholder={"1.0"}
            _disabled={{
              opacity: 1,
            }}
            backgroundColor={inputBGColor}
            disabled={disabled}
            isReadOnly={disabled}
            fontSize={fontSize}
            height={height}
            paddingY={paddingY}
            _hover={hoverStyle}
            _placeholder={placeholderStyle}
          />
        </Wrap>
      );
    case "GB":
    case "UK":
      return (
        <>
          <Flex gap={2} align="center">
            <Text minWidth="max-content" fontSize="xl">
              6 /{" "}
            </Text>
            <Input
              data-testid={dataTestId}
              type="text"
              borderColor="gray.500"
              name={name}
              value={value}
              width="24"
              onChange={(e) => {
                onChange?.(e.target.value);
              }}
              placeholder={"6"}
              _disabled={{
                opacity: 1,
              }}
              backgroundColor={inputBGColor}
              disabled={disabled}
              isReadOnly={disabled}
              fontSize={fontSize}
              height={height}
              paddingY={paddingY}
              _hover={hoverStyle}
              _placeholder={placeholderStyle}
            />
          </Flex>
        </>
      );
    default:
      return (
        <>
          <Flex gap={2} align="center">
            <Text minWidth="max-content" fontSize="xl">
              20 /{" "}
            </Text>
            <Input
              data-testid={dataTestId}
              type="text"
              borderColor="gray.500"
              name={name}
              value={value}
              onChange={(e) => {
                onChange?.(e.target.value);
              }}
              width="24"
              placeholder={"20"}
              _disabled={{
                opacity: 1,
              }}
              backgroundColor={inputBGColor}
              disabled={disabled}
              isReadOnly={disabled}
              fontSize={fontSize}
              height={height}
              paddingY={paddingY}
              _hover={hoverStyle}
              _placeholder={placeholderStyle}
            />
          </Flex>
        </>
      );
  }
});
